<script setup lang="ts">
import FloatingTooltip from "@/components/ui/FloatingTooltip.vue";
import LargeSlideToggle from "@/components/ui/LargeSlideToggle.vue";
import SlideToggle from "@/components/ui/SlideToggle.vue";
import { useDatasourceStore } from "@/stores/datasource";

const {
  disabled = false,
  disableReason = "",
  variant = "sliding",
} = defineProps<{
  disabled?: boolean;
  disableReason?: string;
  variant?: "sliding" | "toggle";
}>();

const datasource = useDatasourceStore();
</script>

<template>
  <FloatingTooltip :enabled="disabled && disableReason?.length > 0" :text="disableReason">
    <!-- Sliding variant (default) -->
    <LargeSlideToggle
      v-if="variant === 'sliding'"
      v-model:is-toggled="datasource.isTestDatasource"
      :disabled="disabled"
      left-label="Train"
      right-label="Test"
      left-icon="icon icon-receipt"
      right-icon="icon icon-signal"
      :aria-label="`Toggle datasource: ${datasource.isTestDatasource ? 'Test' : 'Train'}`"
    />

    <!-- Toggle variant -->
    <div v-else class="datasources datasources-toggle" :class="{ disabled: disabled }">
      <div class="datasource" :class="{ selected: !datasource.isTestDatasource }">
        <i class="icon icon-receipt" /> Train
      </div>
      <SlideToggle
        v-model:is-toggled="datasource.isTestDatasource"
        :disabled="disabled"
        :disabled-state="false"
      />
      <div class="datasource" :class="{ selected: datasource.isTestDatasource }">
        <i class="icon icon-signal" /> Test
      </div>
    </div>
  </FloatingTooltip>
</template>

<style scoped>
/* Shared disabled styles */
.datasources.disabled {
  filter: grayscale(1);
  opacity: 0.5;
  pointer-events: none;
}

/* Toggle variant styles */
.datasources-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: right;
  gap: var(--numbers-6);
  transition:
    filter var(--animation-duration) var(--animation-easing),
    opacity var(--animation-duration) var(--animation-easing),
    background-color var(--animation-duration) var(--animation-easing);

  .datasource {
    color: var(--content-secondary);
    transition: color var(--animation-duration) var(--animation-easing);

    &.selected {
      color: var(--content-brand);
    }
  }
}
</style>
